import { SourcePage } from "shared/taskTypeMap";
import { feedbackSourcePages } from "./constants";
import { attributeSource } from "../../lib/constants";

export const isFeedbackEnabledForTask = (taskType) => {
    return feedbackSourcePages.includes(SourcePage[taskType]);
};

export const isAiSupportedAttribute = (attr) => {
    return attr.additionalInfo?.attributeSource === attributeSource.OCR;
};

export const isAttributeFeedbackSupported = (attr, taskType) => {
    return isFeedbackEnabledForTask(taskType) && isAiSupportedAttribute(attr);
};

export const buildUpdateFeedbackPayload = (values) => {
    return {
        feedbackType: values.feedbackType,
        feedbackText: (values.feedbackText || "").trim(),
    };
};

export const buildCreateFeedbackPayload = ({ attributeUuid, values }) => {
    return {
        attributeUuid,
        ...buildUpdateFeedbackPayload(values),
    };
};
